import { useTranslation } from 'react-i18next'

import { useTimeZone, useUserData } from '../../../../../../hooks'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import {
  APPLICANT_DECISION_STEP,
  QA_NAME_APPLICANT_DECISION_SELECTED_BY,
} from '../ApplicantDecisionPanel.constants'
import { getApplicantDecisionSelectedPerson } from '../ApplicantDecisionPanel.utils.rows'
import { ApplicantDecisionPerson } from '../ApplicantDecisionPerson'
import { ApplicantDecisionStep } from '../ApplicantDecisionStep'

function ApplicantDecisionSelectionStep() {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const timezone = useTimeZone()

  const { applicantData } = useApplicantProfileContext()

  return (
    <ApplicantDecisionStep
      label={t('RentalPortal.ApplicantDecisionSelectedByLedgerKey')}
      qaName={QA_NAME_APPLICANT_DECISION_SELECTED_BY}
      step={APPLICANT_DECISION_STEP.selection}
    >
      <ApplicantDecisionPerson
        {...getApplicantDecisionSelectedPerson({
          applicantData,
          currentUser,
          t,
          timezone,
        })}
      />
    </ApplicantDecisionStep>
  )
}

export default ApplicantDecisionSelectionStep
